/* const blue = '#3bb2d0';
const orange = '#fbb03b';
const white = '#fff'; */

const darkBlue = '#343745';
const blue = '#5E6278';
const orange = '#efa21e';
const white = '#fff';

export const drawThemeUpload =  [

  
  // Polygons
  //   Solid fill
  //   Active state defines color
  {
    'id': 'gl-draw-polygon-fill',
    'type': 'fill',
    'filter': [
      'all',
      ['==', '$type', 'Polygon'],
    ],
    'paint': {
      'fill-color': [
        'case',
        ['==', ['get', 'active'], 'true'], blue,
        blue,
      ],
      'fill-opacity': 0.6,
    },
  },
  // Lines
  // Polygon
  //   Matches Lines AND Polygons
  //   Active state defines color
  /* {
    'id': 'gl-draw-lines',
    'type': 'line',
    'filter': [
      'all',
      ['==', '$type', 'LineString'],
      ['!=', 'meta', 'box']
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round',
    },
    'paint': {
      'line-color': [
        'case',
        ['==', ['get', 'active'], 'true'], blue,
        blue,
      ],
      'line-dasharray': [
        'case',
        ['==', ['get', 'active'], 'true'], [1, 2],
        [2, 0],
      ],
      'line-width': 4,
    },
  }, */
  {
    'id': 'gl-draw-lines',
    'type': 'line',
    'filter': [
      'all',
      ['==', '$type', 'Polygon'],
    ],
    'layout': {
      'line-cap': 'round',
      'line-join': 'round',
    },
    'paint': {
      'line-color': [
        'case',
        ['==', ['get', 'active'], 'true'], blue,
        blue,
      ],
      'line-dasharray': [
        'case',
        ['==', ['get', 'active'], 'true'], [1, 2],
        [2, 0],
      ],
      'line-width': 4,
    },
  },
  // Points
  //   Circle with an outline
  //   Active state defines size and color
/*   {
    'id': 'gl-draw-point-outer',
    'type': 'circle',
    'filter': [
      'all',
      ['==', '$type', 'Point'],
      ['==', 'meta', 'feature'],
    ],
    'paint': {
      'circle-radius': [
        'case',
        ['==', ['get', 'active'], 'true'], 9,
        7,
      ],
      'circle-color': white,
    },
  },
  {
    'id': 'gl-draw-point-inner',
    'type': 'circle',
    'filter': [
      'all',
      ['==', '$type', 'Point'],
      ['==', 'meta', 'feature'],
    ],
    'paint': {
      'circle-radius': [
        'case',
        ['==', ['get', 'active'], 'true'], 7,
        5,
      ],
      'circle-color': [
        'case',
        ['==', ['get', 'active'], 'true'], darkBlue,
        darkBlue,
      ],
    },
  }, */
  // Vertex
  //   Visible when editing polygons and lines
  //   Similar behaviour to Points
  //   Active state defines size
/*   {
    'id': 'gl-draw-vertex-outer',
    'type': 'circle',
    'filter': [
      'all',
      ['==', '$type', 'Point'],
      ['==', 'meta', 'vertex'],
      ['!=', 'mode', 'simple_select'],
    ],
    'paint': {
      'circle-radius': [
        'case',
        ['==', ['get', 'active'], 'true'], 9,
        7,
      ],
      'circle-color': white,
    },
  },
  {
    'id': 'gl-draw-vertex-inner',
    'type': 'circle',
    'filter': [
      'all',
      ['==', '$type', 'Point'],
      ['==', 'meta', 'vertex'],
      ['!=', 'mode', 'simple_select'],
    ],
    'paint': {
      'circle-radius': [
        'case',
        ['==', ['get', 'active'], 'true'], 7,
        5,
      ],
      'circle-color':[
        'case',
        ['==', ['get', 'active'], 'true'], orange,
        darkBlue,
      ],
    },
  }, */
  // Midpoint
  //   Visible when editing polygons and lines
  //   Tapping or dragging them adds a new vertex to the feature
  /* {
    'id': 'gl-draw-midpoint',
    'type': 'circle',
    'filter': [
      'all',
      ['==', 'meta', 'midpoint'],
    ],
    'paint': {
      'circle-radius': 5,
      'circle-color': darkBlue,
    },
  }, */
   // Uploaded polygon
   {
    id: 'gl-draw-rotate-handles',
    type: 'symbol',
    filter: ['all', ['==', '$type', 'Point']/* , ['==', 'meta', 'rotate_handle'] */],
    layout: {
      'icon-image': 'rotate-handle',
      'icon-size': 0.5,
      'icon-ignore-placement': true,
      'icon-allow-overlap': true
    }
  },
   {
    'id': 'gl-draw-rotate-bbox',
    'type': 'line',
    /* 'source': 'mapbox-gl-draw-cold',  */
    'filter': ['all', /* ['==', 'meta', 'box'], */['==', '$type', 'LineString']],
    'paint': {
      'line-color': orange,          // same colour you use elsewhere
      'line-width': 2,
      'line-dasharray': [2, 2]          // ← dashes
    },
    'layout': { 'line-join': 'round' }
  },
   
];